const fileInput = document.getElementById("customImage");
const uploadArea = document.getElementById("upload-area");
const previewContainer = document.getElementById("photo-preview-container");
const previewImage = document.getElementById("photo-preview");
const removePhoto = document.getElementById("remove-photo");

fileInput.addEventListener("change", function () {
  const file = this.files[0];
  if (file) {
    const maxSizeInBytes = 3 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
        fileInput.value = ""; // Clear the file input
        alert("Image size must be less than 3MB.");
        return;
    }
    const reader = new FileReader();

    reader.onload = function (e) {
      previewImage.src = e.target.result;
      previewImage.style.display = "block";
      removePhoto.style.display = "block";
      previewContainer.style.display = "flex";
      uploadArea.style.display = "none";
    };

    reader.readAsDataURL(file);
  }
});

removePhoto.addEventListener("click", function () {
  previewImage.src = "";
  previewImage.style.display = "none";
  removePhoto.style.display = "none";
  previewContainer.style.display = "none";
  uploadArea.style.display = "block";
  fileInput.value = "";
});
